import Swiper, { Navigation, Pagination } from "swiper";

const ArchiveProduct = {
  init() {
    this.events();
    this.productsSlider();
  },

  events() {
  },

  productsSlider() {
    const shopEl = $(".products-slider-block");
    if (shopEl.length) {
      new Swiper(shopEl.find(".products-slider")[0], {
        modules: [Pagination, Navigation],
        slidesPerView: "auto",
        spaceBetween: 20,
        pagination: {
          el: shopEl.find(".swiper-pagination")[0],
          bulletElement: "button",
          dynamicBullets: true,
          dynamicMainBullets: 1,
          clickable: true,
        },
        navigation: {
          prevEl: shopEl.find(".swiper-button-prev")[0],
          nextEl: shopEl.find(".swiper-button-next")[0],
        },
        breakpoints: {
          1200: {
            slidesPerGroup: 4,
          },
        },
      });
    }
  },

};
export default ArchiveProduct;
